const _=72e5,e="__expiration__";export{e as DEFAULT_EXPIRATION_KEY_PREFIX,_ as DEFAULT_EXPIRATION_TIME};
